import { useNavigation } from '@react-navigation/native';
import { NavigationToggle } from 'design-system';
import { PropsWithChildren, useCallback } from 'react';
import { strings } from 'strings';

type Link = 'ListClaims' | 'ListResponses';

type Props = PropsWithChildren<{
  active: Link;
}>;

export const ClaimListToggle: React.FC<Props> = ({ active, children }) => {
  const navigation = useNavigation();

  const navigate = useCallback(
    (screen: Link) => {
      navigation.navigate('Admin', {
        screen: 'Claim',
        params: {
          screen,
        },
      });
    },
    [navigation]
  );

  return (
    <NavigationToggle
      active={active}
      navigate={navigate}
      options={[
        {
          value: 'ListClaims',
          display: strings.ClaimNavigationToggleClaim,
        },
        {
          value: 'ListResponses',
          display: strings.ClaimNavigationToggleResponse,
        },
      ]}
    >
      {children}
    </NavigationToggle>
  );
};
